import React from "react";
// import "./index.css";

export default function FAQ() {
  const faqBoxStyle = {
    background: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    // boxShadow: '0px 0px 10px #2a6f97',
    // background: '#8080801f',
  };

  return (
    <div className="container card-design1">
      <div className="row justify-content-center">
        <div className="col-12 col-md-12 col-lg-11 m-auto ">
          <div className="content ">
            <div className="col-12 content-head">
              <div
                className="mbr-section-head"
                style={{ marginBottom: "15px" }}
              >
                <h4 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
                  <strong className="heading-border">FAQs</strong>
                </h4>
              </div>
            </div>

            <div
              id="bootstrap-accordion_12"
              className="panel-group accordionStyles accordion"
              role="tablist"
              aria-multiselectable="true"
            >
              <div className="card p-0" style={faqBoxStyle}>
                <div
                  className="card-header faq-card"
                  role="tab"
                  id="headingOne"
                >
                  <a
                    role="button"
                    className="panel-title collapsed"
                    data-toggle="collapse"
                    data-bs-toggle="collapse"
                    data-core=""
                    href="#collapse1_12"
                    aria-expanded="false"
                    aria-controls="collapse1"
                  >
                    <h6 className="panel-title-edit mbr-semibold mbr-fonts-style mb-0 p-2 display-7">
                      Q1. What is ITSC HMIS (eSehat)?
                    </h6>
                    <span className="fa fa-angle-up collapsed span" />
                  </a>
                </div>
                <div
                  id="collapse1_12"
                  className="panel-collapse noScroll collapse"
                  role="tabpanel"
                  aria-labelledby="headingOne"
                  data-parent="#accordion"
                  data-bs-parent="#bootstrap-accordion_12"
                >
                  <div className="panel-body">
                    <p className="mbr-fonts-style panel-text p-2 display-7">
                      A: ITSC HMIS (eSehat) is a comprehensive health care
                      software solution developed in India by ITSC. It is
                      designed to manage various aspects of health care
                      delivery, including patient management, billing, inventory
                      control, and appointment scheduling.
                    </p>
                  </div>
                </div>
              </div>

              <div className="card p-0" style={faqBoxStyle}>
                <div
                  className="card-header faq-card"
                  role="tab"
                  id="headingOne"
                >
                  <a
                    role="button"
                    className="panel-title collapsed"
                    data-toggle="collapse"
                    data-bs-toggle="collapse"
                    data-core=""
                    href="#collapse2_12"
                    aria-expanded="false"
                    aria-controls="collapse2"
                  >
                    <h6 className="panel-title-edit mbr-semibold mbr-fonts-style mb-0 p-2 display-7">
                      Q2. Who are the target users of ITSC HMIS (eSehat)?
                    </h6>
                    <span className="fa fa-angle-up collapsed span" />
                  </a>
                </div>
                <div
                  id="collapse2_12"
                  className="panel-collapse noScroll collapse"
                  role="tabpanel"
                  aria-labelledby="headingOne"
                  data-parent="#accordion"
                  data-bs-parent="#bootstrap-accordion_12"
                >
                  <div className="panel-body">
                    <p className="mbr-fonts-style panel-text display-7 p-2">
                      A: ITSC HMIS (eSehat) caters to a wide range of health
                      care providers, including hospitals, clinics, pharmacies,
                      and diagnostic centers.
                    </p>
                  </div>
                </div>
              </div>

              <div className="card p-0" style={faqBoxStyle}>
                <div
                  className="card-header faq-card"
                  role="tab"
                  id="headingOne"
                >
                  <a
                    role="button"
                    className="panel-title collapsed"
                    data-toggle="collapse"
                    data-bs-toggle="collapse"
                    data-core=""
                    href="#collapse3_12"
                    aria-expanded="false"
                    aria-controls="collapse3"
                  >
                    <h6 className="panel-title-edit mbr-semibold p-2 mbr-fonts-style mb-0 display-7">
                      Q3 What are the key features of ITSC HMIS (eSehat)?
                    </h6>
                    <span className="fa fa-angle-up collapsed span" />
                  </a>
                </div>
                <div
                  id="collapse3_12"
                  className="panel-collapse noScroll collapse"
                  role="tabpanel"
                  aria-labelledby="headingOne"
                  data-parent="#accordion"
                  data-bs-parent="#bootstrap-accordion_12"
                >
                  <div className="panel-body p-2">
                    <p className="mbr-fonts-style panel-text display-7">
                      A: ITSC HMIS (eSehat) offers a range of features,
                      including:
                    </p>
                    <p className="mbr-fonts-style panel-text display-7">
                      * Patient Management: Includes patient registration,
                      demographic data entry, medical history tracking, and
                      appointment scheduling.
                    </p>
                    <p className="mbr-fonts-style panel-text display-7">
                      * Billing and Insurance: Handles claims processing,
                      payment tracking, and insurance reimbursements.
                    </p>
                    <p className="mbr-fonts-style panel-text display-7">
                      * Reporting and Analytics: Provides insights into patient
                      demographics, service utilization, and financial
                      performance.
                    </p>
                    <p className="mbr-fonts-style panel-text display-7">
                      * Integration: Offers seamless integration with other
                      health care systems, such as laboratory information
                      systems (LIS).
                    </p>
                  </div>
                </div>
              </div>

              <div className="card p-0" style={faqBoxStyle}>
                <div
                  className="card-header faq-card"
                  role="tab"
                  id="headingOne"
                >
                  <a
                    role="button"
                    className="panel-title collapsed"
                    data-toggle="collapse"
                    data-bs-toggle="collapse"
                    data-core=""
                    href="#collapse4_12"
                    aria-expanded="false"
                    aria-controls="collapse4"
                  >
                    <h6 className="panel-title-edit mbr-semibold mbr-fonts-style mb-0 display-7 p-2">
                      Q4. What are the benefits of using ITSC HMIS (eSehat)?
                    </h6>
                    <span className="fa fa-angle-up collapsed span" />
                  </a>
                </div>
                <div
                  id="collapse4_12"
                  className="panel-collapse noScroll collapse"
                  role="tabpanel"
                  aria-labelledby="headingOne"
                  data-parent="#accordion"
                  data-bs-parent="#bootstrap-accordion_12"
                >
                  <div className="panel-body p-2">
                    <p className="mbr-fonts-style panel-text display-7">
                      A: ITSC HMIS (eSehat) offers several benefits, such as:
                    </p>
                    <p className="mbr-fonts-style panel-text display-7">
                      * Improved Efficiency: Streamlines administrative
                      processes, reduces paperwork, and saves time.
                    </p>
                    <p className="mbr-fonts-style panel-text display-7">
                      * Enhanced Patient Care: Provides better access to patient
                      information, facilitates communication, and improves
                      overall patient experience.
                    </p>

                    <p className="mbr-fonts-style panel-text display-7">
                      * Increased Revenue: Streamlines billing and insurance
                      processes, improving financial management.
                    </p>

                    <p className="mbr-fonts-style panel-text display-7">
                      * Reduced Costs: Automates tasks, minimizes errors, and
                      optimizes resource utilization.
                    </p>

                    <p className="mbr-fonts-style panel-text display-7">
                      * Compliance with Regulations: Helps healthcare providers
                      comply with relevant regulatory standards.
                    </p>
                  </div>
                </div>
              </div>
              <div className="card p-0" style={faqBoxStyle}>
                <div
                  className="card-header faq-card"
                  role="tab"
                  id="headingOne"
                >
                  <a
                    role="button"
                    className="panel-title collapsed"
                    data-toggle="collapse"
                    data-bs-toggle="collapse"
                    data-core=""
                    href="#collapse5_12"
                    aria-expanded="false"
                    aria-controls="collapse5"
                  >
                    <h6 className="panel-title-edit mbr-semibold mbr-fonts-style mb-0 display-7 p-2">
                      Q5. What are the pricing options for ITSC HMIS (eSehat)?
                    </h6>
                    <span className="fa fa-angle-up collapsed span" />
                  </a>
                </div>
                <div
                  id="collapse5_12"
                  className="panel-collapse noScroll collapse"
                  role="tabpanel"
                  aria-labelledby="headingOne"
                  data-parent="#accordion"
                  data-bs-parent="#bootstrap-accordion_12"
                >
                  <div className="panel-body p-2">
                    <p className="mbr-fonts-style panel-text display-7">
                      A: ITSC HMIS (eSehat) offers flexible pricing plans based
                      on the size and requirements of the healthcare facility.
                      Contact their sales team for a customized quote.
                    </p>
                  </div>
                </div>
              </div>

              <div className="card p-0" style={faqBoxStyle}>
                <div
                  className="card-header faq-card"
                  role="tab"
                  id="headingOne"
                >
                  <a
                    role="button"
                    className="panel-title collapsed"
                    data-toggle="collapse"
                    data-bs-toggle="collapse"
                    data-core=""
                    href="#collapse6_12"
                    aria-expanded="false"
                    aria-controls="collapse5"
                  >
                    <h6 className="panel-title-edit mbr-semibold mbr-fonts-style mb-0 display-7 p-2">
                      Q6. How can I learn more about ITSC HMIS (eSehat)?
                    </h6>
                    <span className="fa fa-angle-up collapsed span" />
                  </a>
                </div>
                <div
                  id="collapse6_12"
                  className="panel-collapse noScroll collapse"
                  role="tabpanel"
                  aria-labelledby="headingOne"
                  data-parent="#accordion"
                  data-bs-parent="#bootstrap-accordion_12"
                >
                  <div className="panel-body p-2">
                    <p className="mbr-fonts-style panel-text display-7">
                      A: You can visit the ITSC website, browse their online
                      resources, or contact their customer support team for more
                      information and a demonstration. You can also search for
                      user reviews and testimonials online to gain further
                      insights.{" "}
                    </p>
                  </div>
                </div>
              </div>

              <div className="card p-0 " style={faqBoxStyle}>
                <div
                  className="card-header faq-card"
                  role="tab"
                  id="headingOne"
                >
                  <a
                    role="button"
                    className="panel-title collapsed"
                    data-toggle="collapse"
                    data-bs-toggle="collapse"
                    data-core=""
                    href="#collapse7_12"
                    aria-expanded="false"
                    aria-controls="collapse5"
                  >
                    <h6 className="panel-title-edit mbr-semibold mbr-fonts-style mb-0 display-7 p-2">
                      Q7. Is ITSC HMIS (eSehat) suitable for my healthcare
                      facility?
                    </h6>
                    <span className="fa fa-angle-up collapsed span" />
                  </a>
                </div>
                <div
                  id="collapse7_12"
                  className="panel-collapse noScroll collapse"
                  role="tabpanel"
                  aria-labelledby="headingOne"
                  data-parent="#accordion"
                  data-bs-parent="#bootstrap-accordion_12"
                >
                  <div className="panel-body p-2">
                    <p className="mbr-fonts-style panel-text display-7 p-2">
                      A: ITSC HMIS (eSehat) is designed to be versatile and
                      adaptable to different healthcare settings. Contact their
                      team to discuss your specific needs and determine if their
                      software can meet your requirements.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="card p-0 " style={faqBoxStyle}>
                <div
                  className="card-header faq-card"
                  role="tab"
                  id="headingOne"
                >
                  <a
                    role="button"
                    className="panel-title collapsed"
                    data-toggle="collapse"
                    data-bs-toggle="collapse"
                    data-core=""
                    href="#collapse8_12"
                    aria-expanded="false"
                    aria-controls="collapse5"
                  >
                    <h6 className="panel-title-edit mbr-semibold mbr-fonts-style mb-0 display-7 p-2">
                      Q8. What is the level of support offered by ITSC for ITSC
                      HMIS (eSehat)?
                    </h6>
                    <span className="fa fa-angle-up collapsed span" />
                  </a>
                </div>
                <div
                  id="collapse8_12"
                  className="panel-collapse noScroll collapse"
                  role="tabpanel"
                  aria-labelledby="headingOne"
                  data-parent="#accordion"
                  data-bs-parent="#bootstrap-accordion_12"
                >
                  <div className="panel-body p-2">
                    <p className="mbr-fonts-style panel-text display-7">
                      A: ITSC offers comprehensive support services for their
                      software, including:
                    </p>

                    <p className="mbr-fonts-style panel-text display-7">
                      * Technical Support: Provides assistance with system
                      issues, troubleshooting, and software updates.
                    </p>

                    <p className="mbr-fonts-style panel-text display-7">
                      * Training and Implementation: Offers training programs to
                      familiarize users with the software and assist with
                      implementation.{" "}
                    </p>
                    <p className="mbr-fonts-style panel-text display-7">
                      * Ongoing Maintenance: Provides regular software updates,
                      security patches, and ongoing maintenance to ensure smooth
                      operation.
                    </p>
                  </div>
                </div>
              </div>

              {/* <div className="card p-0 faq-card">
                    <div className="card-header" role="tab" id="headingOne">
                      <a
                        role="button"
                        className="panel-title collapsed"
                        data-toggle="collapse"
                        data-bs-toggle="collapse"
                        data-core=""
                        href="#collapse9_12"
                        aria-expanded="false"
                        aria-controls="collapse5"
                      >
                        <h6
                          className="panel-title-edit mbr-semibold mbr-fonts-style mb-0 display-7"
                         
                        >
                          Q9 How can I learn more about ITSC HMIS (eSehat)?
                        </h6>
                        <span
                          className="fa fa-angle-up collapsed span"
                      
                        />
                      </a>
                    </div>

                    <div
                      id="collapse9_12"
                      className="panel-collapse noScroll collapse"
                      role="tabpanel"
                      aria-labelledby="headingOne"
                      data-parent="#accordion"
                      data-bs-parent="#bootstrap-accordion_12"
                    >
                      <div className="panel-body">
                        <p className="mbr-fonts-style panel-text display-7">
                          A: You can visit the ITSC website, browse their online
                          resources, or contact their customer support team for
                          more information and a demonstration. You can also
                          search for user reviews and testimonials online to
                          gain further insights.{" "}
                        </p>
                      </div>
                    </div>
                  </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
